import { createSlice } from '@reduxjs/toolkit'
import { LayoutBuilderSliceStateType } from '../types'

const initialState: LayoutBuilderSliceStateType = {
  layoutEntity: null,
  layoutResponseJsonObject: null,
  layoutAddedFieldsByFieldName: {},
  normalizedBuilderLayoutData: null,
  layoutBuilderAllEntityFields: {
    elementField: {},
    entityFields: {},
  },
  layoutGroupByUiTypeFields: {},
  layoutRestFields: [],
  quickSelectLookupField: null,
  layoutAddedLookUpFields: [],
  layoutBuilderActiveTab: '',
  layoutAssociatedObject: {},
  layoutBuilderHeaderConfig: null,
  LayoutElementAction: false,
}

const layoutBuilderSlice = createSlice({
  name: 'layoutBuilder',
  initialState: initialState,
  reducers: {
    updateLayoutEntity: (state, action) => {
      state.layoutEntity = action?.payload
    },
    updateLayoutResponseJsonObject: (state, action) => {
      state.layoutResponseJsonObject = action?.payload
    },
    updateLayoutAddedFieldsByFieldName: (state, action) => {
      state.layoutAddedFieldsByFieldName = action?.payload
    },
    updateNormalizedBuilderLayoutData: (state, action) => {
      state.normalizedBuilderLayoutData = action?.payload
    },
    updateLayoutBuilderAllEntityFields: (state, action) => {
      state.layoutBuilderAllEntityFields = action?.payload
    },
    updateLayoutRestFields: (state, action) => {
      state.layoutRestFields = action?.payload
    },
    updateLayoutGroupByUiTypeFields: (state, action) => {
      state.layoutGroupByUiTypeFields = action?.payload
    },
    updateQuickSelectedLookField: (state, action) => {
      state.quickSelectLookupField = action?.payload
    },
    updateLayoutAddedLookUpFields: (state, action) => {
      state.layoutAddedLookUpFields = action?.payload
    },
    updateLayoutBuilderActiveTab: (state, action) => {
      state.layoutBuilderActiveTab = action?.payload
    },
    updateLayoutAssociatedObject: (state, action) => {
      state.layoutAssociatedObject = action?.payload
    },
    updateLayoutBuilderHeaderConfig: (state, action) => {
      state.layoutBuilderHeaderConfig = action?.payload
    },
    updateLayoutElementAction: (state, action) => {
      state.LayoutElementAction = action?.payload
    },
    resetLayoutBuilderConfig: () => initialState,
  },
})

export const {
  updateLayoutEntity,
  updateLayoutResponseJsonObject,
  updateLayoutAddedFieldsByFieldName,
  updateNormalizedBuilderLayoutData,
  updateLayoutGroupByUiTypeFields,
  updateLayoutBuilderAllEntityFields,
  updateLayoutRestFields,
  updateQuickSelectedLookField,
  updateLayoutAddedLookUpFields,
  updateLayoutBuilderActiveTab,
  updateLayoutAssociatedObject,
  updateLayoutBuilderHeaderConfig,
  updateLayoutElementAction,
  resetLayoutBuilderConfig,
} = layoutBuilderSlice.actions
export default layoutBuilderSlice.reducer
